export default "__VITE_ASSET__muvwjmIl__"